import React from 'react';
import { Ollie } from './Ollie';

type OfflineScreenProps = {
    className?: string;
};

export const OfflineScreen: React.FC<OfflineScreenProps> = ({
    className = ""
}) => {
    return (
        <div className={`fixed inset-0 bg-white flex items-center justify-center z-50 ${className}`}>
            <div className="flex flex-col items-center justify-center space-y-8 px-8 text-center">
                {/* Ollie Character */}
                <div className="flex justify-center">
                    <Ollie type="sad" variant="04" size="large" />
                </div>

                {/* Message */}
                <div className="space-y-4">
                    <h2 className="text-osBlack text-xl font-bold leading-relaxed max-w-sm">
                        ObsessLess only works with an internet connection, for now...
                    </h2>
                    <p className="text-osBlack leading-relaxed max-w-xs">
                        We are working on making the experience better and thank you for understanding.
                    </p>
                </div>
            </div>
        </div>
    );
}; 